@if (options.length > 0) {
  <div class="call-obj-selector">
    <p class="call-obj-selector__label">Suggested call objectives:</p>
    <div class="call-obj-selector__list">
      @for (option of options; track option; let i = $index) {
        <button type="button" class="call-obj-tile"
          [disabled]="confirmed"
          (click)="onSelect(option)"
          [attr.aria-label]="'Use call objective option ' + (i + 1)">
          <span class="call-obj-tile__num">{{ i + 1 }}</span>
          <span class="call-obj-tile__text">{{ option }}</span>
        </button>
      }
    </div>
    @if (!confirmed) {
      <p class="call-obj-selector__hint">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        Click a suggestion to load it into the input — you can edit it before sending.
      </p>
    }
  </div>
}
